import { APPCONFIG } from './app.config';

const BASE_URL = APPCONFIG.baseUrl;
const AUTH_BASE_URL = APPCONFIG.authBaseUrl;
const APP_NAME = APPCONFIG.appName;

export type IAPICONFIG = {
	[key: string]: string;
};

export const APICONFIG: IAPICONFIG = {
	//Authentication API
	PROFILE_API: `${AUTH_BASE_URL}/api/auth/pidilite-users/me/`,
	GET_JHAROKHA_TOKEN: `${AUTH_BASE_URL}/api/members/jharokha/jharokha-access-token/`,
	JHAROKHA_PRODUCT: `${BASE_URL}/apis/v.2.0/common/jharokha-product-details/`,
	PCMS_TOKEN: `${AUTH_BASE_URL}/api/members/pcms/pcms-access-token/`,
	LOGIN: `${BASE_URL}/apis/v.1.0/login`,
	EXCHANGE_TOKEN: `${AUTH_BASE_URL}/api/auth/exchange-token/`,
	LOGOUT: `${AUTH_BASE_URL}/api/auth/logout/`,

	//Image Upload API
	PRESIGNED_URL: `${AUTH_BASE_URL}/api/members/${APP_NAME}/upload-presigned/`,
	IMAGE_FETCH_API: `${BASE_URL}/apis/v.1.0/mpower/azure-sas-token/`,
	PRESIGNED_URL_DELETE: `${AUTH_BASE_URL}/api/members/${APP_NAME}/upload-presigned/delete-image/`,

	//KYC Verification API
	KYC_VERIFICATION_API: `${AUTH_BASE_URL}/api/members/kyc/account/`,
	PHYSICAL_VERIFICATION: `${AUTH_BASE_URL}/api/members/${APP_NAME}/physical-verification/`,

	//One to Many Meetings API
	MEETINGS_API: `${AUTH_BASE_URL}/api/meetings/cc/one-to-many-meetings/`,
	SELECT_PARTICIPANTS_API: `${AUTH_BASE_URL}/api/meetings/${APP_NAME}/select-participants/`,

	//Member API
	LEAD_USER_API: `${AUTH_BASE_URL}/api/members/${APP_NAME}/lead/`,
	ALL_END_USER_API: `${AUTH_BASE_URL}/api/members/${APP_NAME}/end-user/`,
	LEAD_USER_MORE_DETAILS: `${AUTH_BASE_URL}/api/members/${APP_NAME}/lead-more-details/`,
	END_USER_MORE_DETAILS: `${AUTH_BASE_URL}/api/members/${APP_NAME}/end-user-more-details/`,
	CONTRACTOR_DETAILS: `${AUTH_BASE_URL}/api/members/${APP_NAME}/contractor-360/`,
	COMPETITION_DETAILS: `${AUTH_BASE_URL}/api/members/${APP_NAME}/competition-details/`,

	//Dropdown API
	END_USER_CATEGORY_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/end-user-categories/`,
	DEALERS_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/dealer-list/`,
	PRODUCTS_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/product2/`,
	TOWNS_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/town-list/`,
	CLUBS_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/club-list/`,
	VENUES_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/venue-list/`,
	SURFACES_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/surfaces/`,
	MEETING_MODULES_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/module-name/`,
	MEETING_TYPES_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/meeting-type/`,
	BTL_OBJECTIVES_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/btl-objective/`,
	BTL_OBJECTIVE_PRODUCTS_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/btl-objective/product/`,
	TYPE_OF_CONSTRUCTION_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/types-of-construction/`,
	PROJECT_CLASSIFICATION_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/project-classifications/`,
	STAGES_OF_CONSTRUCTION_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/stages-of-construction/`,
	SOURCE_OF_SITE_LEAD_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/source-of-site-lead/`,
	DASHBOARD_BANNERS: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/banners/`,
	SHADES_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/shades/`,
	PRODUCT_MASTER_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/product-master/`,
	TOWN_LIST_API: `${AUTH_BASE_URL}/api/dropdowns/${APP_NAME}/cc-town-list/`,

	//Capillary API
	CAPILLARY_API: `${AUTH_BASE_URL}/api/capillary/`,

	//Phone Validation API
	PHONE_VALIDATE_API: `${AUTH_BASE_URL}/api/members/${APP_NAME}/phone-validate/`,

	//One to One Meetings API
	ONE_TO_ONE_MEETINGS_LIST: `${AUTH_BASE_URL}/api/meetings/${APP_NAME}/one-to-one-meetings/`,
	LAST_VISIT_INFO: `${AUTH_BASE_URL}/api/meetings/${APP_NAME}/one-to-one-meetings/stakeholder-visit-info/`,

	//User Transfer API
	USER_TRANSFER_LIST: `${AUTH_BASE_URL}/api/members/user-transfer/user-transfer-request/`,
	BDE_LIST: `${AUTH_BASE_URL}/api/members/user-transfer/bde-list/`,

	//Socket API
	SOCKET_ENDPOINT: `wss://mpowerdjangouat.pidilite.com/ws/campaign`,

	//Case API
	CASE_LIST_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/cases/`,

	//DFCC Clubs API
	DFCC_CLUBS_API: `${AUTH_BASE_URL}/api/members/dfcc-club/club/`,
	DFCC_UPDATE_CLUB_MEMBER_API: `${AUTH_BASE_URL}/api/members/dfcc-club/club/bulk-update/`,

	//Site Lead API
	SITE_LIST_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/sites/`,
	PRODUCT_SAMPLING_LIST_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/product-sampling/`,
	RAINCOAT_PREVIEW_LIST_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/raincoat-preview/`,

	//Prospective Site API
	PROSPECTIVE_SITE_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/prospective-sites/`,

	//Dashboard API
	DASHBOARD_FIELD_WORKING_API: `${AUTH_BASE_URL}/api/dashboard/${APP_NAME}/field-working-days/`,
	DASHBOARD_SUMMARY_API: `${AUTH_BASE_URL}/api/dashboard/${APP_NAME}/dashboard-summary/`,
	KAEDASHBOARD_SUMMARY_API: `${AUTH_BASE_URL}/api/dashboard/${APP_NAME}/kaenc-kaerr-dashboard-summary/`,
	DASHBOARD_TODAYS_MEETINGS_API: `${AUTH_BASE_URL}/api/dashboard/${APP_NAME}/get-todays-meetings/`,
	KAEDASHBOARD_SITE_SUMMARY_API: `${AUTH_BASE_URL}/api/dashboard/${APP_NAME}/kaenc-kaerr-dashboard-summary/site-summary/`,

	//Site Lead List API
	SITE_LEAD_LIST_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/sites/list-with-stage/`,
	IRDR_PDF_API: `${AUTH_BASE_URL}/api/site-lead/${APP_NAME}/sites/legacy-irdr-pdf/`,
};
